import { ReactComponent as TangledStream } from '../components/icons/TangledStream.svg'
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';


const CreatePostStep = ({ step, activeStep }) => {

    if (step !== activeStep) {
        return null;
    }

    return (<Box display={'flex'} flexGrow={1} width={320} height={320}>
        <Stack display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Typography sx={{color: 'white'}} variant={'body1'} >
                {`The Poll App will create a post that appears in the Tangled feed.  You can schedule the post to appear in the future.  If you don't want to post now, you will still be able to access the configuration for this poll.`}
            </Typography>
            <TangledStream style={{width: '20rem'}}/>
        </Stack>
    </Box>);
}

CreatePostStep.propTypes = {
    step: PropTypes.number,
    activeStep: PropTypes.number
}
export default CreatePostStep;